import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate, useNavigation, useResolvedPath } from "react-router";
import { useEffect, useState } from "react";
import { useStore } from "../../../hooks/store";
import { useHistory } from "react-router";
export default function NavBar() {
  const store = useStore();
  const defState = {
    "": false,
    pdd: false,
    video: false,
    news: false,
    sessions: false,
  };
  const [isActive, setActive] = useState({ ...defState });

  let path = useResolvedPath();

  useEffect(() => {
    const resolvedPath = path.pathname.replace("/", "");
    setActive({ ...defState, [resolvedPath]: true });
  }, [path]);

  const navHook = useNavigate();

  const handleNav = (e) => {
    const destanation = e.target.id;
    navHook(destanation);
  };
  const handleLogout = () => {
    store.logout();
    navHook("/login");
  };

  const isShown = !path.pathname.includes("login");

  return (
    isShown && (
      <nav>
        <div style={{ display: "flex", gap: "5px" }}>
          <Button
            disabled={path.pathname.includes("bilet")}
            onClick={handleNav}
            variant={path.pathname.includes("bilet") ? "contained" : "outlined"}
            id="bilet">
            Билеты
          </Button>
          <Button
            disabled={path.pathname.includes("pdd")}
            onClick={handleNav}
            variant={path.pathname.includes("pdd") ? "contained" : "outlined"}
            id="pdd">
            ПДД
          </Button>
          <Button
            disabled={isActive.video}
            onClick={handleNav}
            variant={isActive.video ? "contained" : "outlined"}
            id="video">
            Видеоуроки
          </Button>
          <Button
            disabled={path.pathname.includes("news")}
            onClick={handleNav}
            variant={path.pathname.includes("news") ? "contained" : "outlined"}
            id="news">
            Новости
          </Button>
          <Button
            disabled={path.pathname.includes("user")}
            onClick={handleNav}
            variant={path.pathname.includes("user") ? "contained" : "outlined"}
            id="user">
            Пользователи
          </Button>
          <Button
            disabled={path.pathname.includes("school")}
            onClick={handleNav}
            variant={
              path.pathname.includes("school") ? "contained" : "outlined"
            }
            id="school">
            Автошкола
          </Button>
          <Button
            disabled={isActive.sessions}
            onClick={handleNav}
            variant={isActive.sessions ? "contained" : "outlined"}
            id="sessions">
            Привязка устройства
          </Button>
        </div>
        <Button variant="contained">
          <LogoutIcon fontSize="small" onClick={handleLogout} />
        </Button>
      </nav>
    )
  );
}
